import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FinishedFabricProperty2ReferenceService extends BaseReferenceService {
  constructor() {
    super('FinishedFabricProperty2Reference');
  }
}
